import React, { Component } from 'react';
import { base } from '../../base';
import ProductsListView from '../views/ProductsListView';

class ProductListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            products: []
        };
    }

    componentDidMount() {
        this.refData = base.syncState('products', {
            context: this,
            asArray: true,
            state: 'products',
        })
    }

    componentWillUnmount() {
        base.removeBinding(this.refData);
    }

    render() {
        return <ProductsListView products={this.state.products} />;
    }
}

export default ProductListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/ProductListContainer.jsx